import React from 'react';

// Utility function to trim words
const trimWords = (text, wordLimit, ellipsis = '...') => {
  const words = text.split(' ');
  if (words.length <= wordLimit) {
    return text;
  }
  return words.slice(0, wordLimit).join(' ') + ellipsis;
};

// TrimmedParagraph component
const TrimmedParagraph = ({ text, wordLimit, ellipsis }) => {
  const trimmedText = trimWords(text, wordLimit, ellipsis);
  return <p className="text-body">{trimmedText}</p>;
};

export default TrimmedParagraph;